import React from "react";
import _ from "lodash";
import { assetsPath } from "../../utils";

const baseAssetUrl = assetsPath("phuket-laguna-park-2");
const baseAssetVideoUrl = `${baseAssetUrl}/videos`;

const aerialImg1 = `${baseAssetUrl}/images/gallery/aerial/Aerial 1.jpg`;
const aerialImg2 = `${baseAssetUrl}/images/gallery/aerial/Aerial 2.jpg`;
const aerialImg3 = `${baseAssetUrl}/images/gallery/aerial/Aerial 3.jpg`;

const commonAreaImg1 = `${baseAssetUrl}/images/gallery/common-area/Common Area 1.jpg`;
const commonAreaImg2 = `${baseAssetUrl}/images/gallery/common-area/Common Area 2.jpg`;
const commonAreaImg3 = `${baseAssetUrl}/images/gallery/common-area/Common Area 3.jpg`;
const commonAreaImg4 = `${baseAssetUrl}/images/gallery/common-area/Common Area 4.jpg`;

const destinationLifestyleImg1 = `${baseAssetUrl}/images/gallery/destination-lifestyle/Destination - lifestyle 1.jpg`;
const destinationLifestyleImg2 = `${baseAssetUrl}/images/gallery/destination-lifestyle/Destination - lifestyle 2.jpg`;
const destinationLifestyleImg3 = `${baseAssetUrl}/images/gallery/destination-lifestyle/Destination - lifestyle 3.jpg`;
const destinationLifestyleImg4 = `${baseAssetUrl}/images/gallery/destination-lifestyle/Destination - lifestyle 4.jpg`;
const destinationLifestyleImg5 = `${baseAssetUrl}/images/gallery/destination-lifestyle/Destination - lifestyle 5.jpg`;
const destinationLifestyleImg6 = `${baseAssetUrl}/images/gallery/destination-lifestyle/Destination - lifestyle 6.jpg`;
const destinationLifestyleImg7 = `${baseAssetUrl}/images/gallery/destination-lifestyle/Destination - lifestyle 7.jpg`;
const destinationLifestyleImg8 = `${baseAssetUrl}/images/gallery/destination-lifestyle/Destination - lifestyle 8.jpg`;
const destinationLifestyleImg9 = `${baseAssetUrl}/images/gallery/destination-lifestyle/Destination - lifestyle 9.jpg`;
const destinationLifestyleImg10 = `${baseAssetUrl}/images/gallery/destination-lifestyle/Destination - lifestyle 10.jpg`;

const exteriorImg1 = `${baseAssetUrl}/images/gallery/exterior/Exterior Townhome 1.jpg`;
const exteriorImg2 = `${baseAssetUrl}/images/gallery/exterior/Exterior Townhome 2.jpg`;
const exteriorImg3 = `${baseAssetUrl}/images/gallery/exterior/Exterior Townhome 3.jpg`;
const exteriorImg4 = `${baseAssetUrl}/images/gallery/exterior/Exterior Villa 1.jpg`;
const exteriorImg5 = `${baseAssetUrl}/images/gallery/exterior/Exterior Villa 2.jpg`;
const exteriorImg6 = `${baseAssetUrl}/images/gallery/exterior/Exterior Villa 3.jpg`;
const exteriorImg7 = `${baseAssetUrl}/images/gallery/exterior/Exterior Villa 4.jpg`;
const exteriorImg8 = `${baseAssetUrl}/images/gallery/exterior/Exterior.jpg`;

const interiorImg1 = `${baseAssetUrl}/images/gallery/interior/Interior Townhome Bedroom.jpg`;
const interiorImg2 = `${baseAssetUrl}/images/gallery/interior/Interior Townhome Living Room.jpg`;
const interiorImg3 = `${baseAssetUrl}/images/gallery/interior/Interior Villa Bedroom.jpg`;
const interiorImg4 = `${baseAssetUrl}/images/gallery/interior/Interior Villa Living Room.jpg`;

const residencesLifestyleImg1 = `${baseAssetUrl}/images/gallery/residences-lifestyle/Residences-lifestyle 1.jpg`;
const residencesLifestyleImg2 = `${baseAssetUrl}/images/gallery/residences-lifestyle/Residences-lifestyle 2.jpg`;
const residencesLifestyleImg3 = `${baseAssetUrl}/images/gallery/residences-lifestyle/Residences-lifestyle 3.jpg`;
const residencesLifestyleImg4 = `${baseAssetUrl}/images/gallery/residences-lifestyle/Residences-lifestyle 4.jpg`;
const residencesLifestyleImg5 = `${baseAssetUrl}/images/gallery/residences-lifestyle/Residences-lifestyle 5.jpg`;

const heroShotImg1 = `${baseAssetUrl}/images/gallery/hero-shot/001.LP2-Exterior-Townhomes-003.jpg`;
const heroShotImg2 = `${baseAssetUrl}/images/gallery/hero-shot/002.LP2-Exterior-Villas-004.jpg`;
const heroShotImg3 = `${baseAssetUrl}/images/gallery/hero-shot/003.LP2-Exterior-Villas-006.jpg`;
const heroShotImg4 = `${baseAssetUrl}/images/gallery/hero-shot/004.LP2-Exterior-Villas-007.jpg`;
const heroShotImg5 = `${baseAssetUrl}/images/gallery/hero-shot/006.LP2-Interior-Villas Living room-004.jpg`;
const heroShotImg6 = `${baseAssetUrl}/images/gallery/hero-shot/007.LP2-Interior-Villas Bedroom-003.jpg`;
const heroShotImg7 = `${baseAssetUrl}/images/gallery/hero-shot/008.LP2-Interior-Townhomes Living room-002.jpg`;
const heroShotImg8 = `${baseAssetUrl}/images/gallery/hero-shot/009.LP2-Interior-Townhomes Bedroom-001.jpg`;

// const residencesAerial1 = `${baseAssetUrl}/images/gallery/images/aerial/1.jpg`;
// const residencesAerial2 = `${baseAssetUrl}/images/gallery/images/aerial/2.jpg`;
// const residencesAerial3 = `${baseAssetUrl}/images/gallery/images/aerial/3.jpg`;

// const residencesExterior1 = `${baseAssetUrl}/images/gallery/images/exterior/1.jpg`;
// const residencesExterior2 = `${baseAssetUrl}/images/gallery/images/exterior/2.jpg`;
// const residencesExterior3 = `${baseAssetUrl}/images/gallery/images/exterior/3.jpg`;
// const residencesExterior4 = `${baseAssetUrl}/images/gallery/images/exterior/4.jpg`;
// const residencesExterior5 = `${baseAssetUrl}/images/gallery/images/exterior/5.jpg`;
// const residencesExterior6 = `${baseAssetUrl}/images/gallery/images/exterior/6.jpg`;
// const residencesExterior7 = `${baseAssetUrl}/images/gallery/images/exterior/7.jpg`;
// const residencesExterior8 = `${baseAssetUrl}/images/gallery/images/exterior/8.jpg`;

// const residencesInterior1 = `${baseAssetUrl}/images/gallery/images/interior/1.jpg`;
// const residencesInterior2 = `${baseAssetUrl}/images/gallery/images/interior/2.jpg`;
// const residencesInterior3 = `${baseAssetUrl}/images/gallery/images/interior/3.jpg`;
// const residencesInterior4 = `${baseAssetUrl}/images/gallery/images/interior/4.jpg`;

// const residencesCommonArea1 = `${baseAssetUrl}/images/gallery/images/common-area/1.jpg`;
// const residencesCommonArea2 = `${baseAssetUrl}/images/gallery/images/common-area/2.jpg`;
// const residencesCommonArea3 = `${baseAssetUrl}/images/gallery/images/common-area/3.jpg`;
// const residencesCommonArea4 = `${baseAssetUrl}/images/gallery/images/common-area/4.jpg`;

// const residencesLifestyle1 = `${baseAssetUrl}/images/gallery/images/residences-lifestyle/1.jpg`;
// const residencesLifestyle2 = `${baseAssetUrl}/images/gallery/images/residences-lifestyle/2.jpg`;
// const residencesLifestyle3 = `${baseAssetUrl}/images/gallery/images/residences-lifestyle/3.jpg`;
// const residencesLifestyle4 = `${baseAssetUrl}/images/gallery/images/residences-lifestyle/4.jpg`;
// const residencesLifestyle5 = `${baseAssetUrl}/images/gallery/images/residences-lifestyle/5.jpg`;

// const destinationLifestyle1 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/1.jpg`;
// const destinationLifestyle2 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/2.jpg`;
// const destinationLifestyle3 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/3.jpg`;
// const destinationLifestyle4 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/4.jpg`;
// const destinationLifestyle5 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/5.jpg`;
// const destinationLifestyle6 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/6.jpg`;
// const destinationLifestyle7 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/7.jpg`;
// const destinationLifestyle8 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/8.jpg`;
// const destinationLifestyle9 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/9.jpg`;
// const destinationLifestyle10 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/10.jpg`;

const video = {
  en: `${baseAssetVideoUrl}/Laguna Park 2 - 3D flythrough_Trilingual_Dec 2019_LowRes.mp4`,
  ru: `${baseAssetVideoUrl}/Laguna Park 2 - 3D flythrough_Trilingual_Dec 2019_LowRes.mp4`,
  cn: `${baseAssetVideoUrl}/Laguna Park 2 - 3D flythrough_Trilingual_Dec 2019_LowRes.mp4`,
};

// const videos = [
//   {
//     titleKey: "propertyVideo",
//     source: {
//       en: `${baseAssetVideoUrl}/video/LP2_2_16x9_EN_Compress.mp4`,
//       ru: `${baseAssetVideoUrl}/video/LP2_2_16x9_EN_Compress.mp4`,
//       cn: `${baseAssetVideoUrl}/video/LP2_2_16x9_EN_Compress.mp4`,
//     },
//     text: {
//       en: ["PROPERTY VIDEO"],
//       cn: ["项目视频"],
//       ru: ["ВИДЕО ПРОЕКТА"],
//     },
//   },
//   {
//     titleKey: "interiorTownHomeVideo",
//     source: {
//       en: `${baseAssetVideoUrl}/images/gallery/video/2.jpg`,
//       ru: `${baseAssetVideoUrl}/images/gallery/video/2.jpg`,
//       cn: `${baseAssetVideoUrl}/images/gallery/video/2.jpg`,
//     },
//     text: {
//       en: ["TOWNHOME"],
//       cn: ["联排别墅"],
//       ru: ["ТАУНХАУСЫ"],
//     },
//   },
//   {
//     titleKey: "interiorVillaVideo",
//     source: {
//       en: `${baseAssetVideoUrl}/images/gallery/video/3.jpg`,
//       ru: `${baseAssetVideoUrl}/images/gallery/video/3.jpg`,
//       cn: `${baseAssetVideoUrl}/images/gallery/video/3.jpg`,
//     },
//     text: {
//       en: ["VILLA"],
//       cn: ["独栋别墅"],
//       ru: ["Виллы"],
//     },
//   },
// ];

const heroShot = [
  { image: heroShotImg1 },
  { image: heroShotImg2 },
  { image: heroShotImg3 },
  { image: heroShotImg4 },
  { image: heroShotImg5 },
  { image: heroShotImg6 },
  { image: heroShotImg7 },
  { image: heroShotImg8 },
];

const categories = [
  {
    id: 1,
    name: "All Images",
  },
  {
    id: 2,
    name: "Aerial",
  },
  {
    id: 3,
    name: "Exterior",
  },
  {
    id: 4,
    name: "Interior",
  },
  {
    id: 5,
    name: "Common Area",
  },
  {
    id: 6,
    name: "Residences - Lifestyle",
  },
  {
    id: 7,
    name: "Destination - Lifestyle",
  },
];

const images = [
  {
    categoryId: 2,
    name: "Aerial - 1",
    image: aerialImg1,
  },
  {
    categoryId: 2,
    name: "Aerial - 2",
    image: aerialImg2,
  },
  {
    categoryId: 2,
    name: "Aerial - 3",
    image: aerialImg3,
  },
  {
    categoryId: 3,
    name: "Exterior",
    image: exteriorImg1,
  },
  {
    categoryId: 3,
    name: "Exterior Townhome 1",
    image: exteriorImg2,
  },
  {
    categoryId: 3,
    name: "Exterior Townhome 2",
    image: exteriorImg3,
  },
  {
    categoryId: 3,
    name: "Exterior Townhome 3",
    image: exteriorImg4,
  },
  {
    categoryId: 3,
    name: "Exterior Villa 1",
    image: exteriorImg5,
  },
  {
    categoryId: 3,
    name: "Exterior Villa 2",
    image: exteriorImg6,
  },
  {
    categoryId: 3,
    name: "Exterior Villa 3",
    image: exteriorImg7,
  },
  {
    categoryId: 3,
    name: "Exterior Villa 4",
    image: exteriorImg8,
  },
  {
    categoryId: 4,
    name: "Interior Townhome Bedroom",
    image: interiorImg1,
  },
  {
    categoryId: 4,
    name: "Interior Townhome Living Room",
    image: interiorImg2,
  },
  {
    categoryId: 4,
    name: "Interior Villa Bedroom",
    image: interiorImg3,
  },
  {
    categoryId: 4,
    name: "Interior Villa Living Room",
    image: interiorImg4,
  },
  {
    categoryId: 5,
    name: "Common Area - 1",
    image: commonAreaImg1,
  },
  {
    categoryId: 5,
    name: "Common Area - 2",
    image: commonAreaImg2,
  },
  {
    categoryId: 5,
    name: "Common Area - 3",
    image: commonAreaImg3,
  },
  {
    categoryId: 5,
    name: "Common Area - 4",
    image: commonAreaImg4,
  },
  {
    categoryId: 6,
    name: "Lifestyle - 1",
    image: residencesLifestyleImg1,
  },
  {
    categoryId: 6,
    name: "Lifestyle - 2",
    image: residencesLifestyleImg2,
  },
  {
    categoryId: 6,
    name: "Lifestyle - 3",
    image: residencesLifestyleImg3,
  },
  {
    categoryId: 6,
    name: "Lifestyle - 4",
    image: residencesLifestyleImg4,
  },
  {
    categoryId: 6,
    name: "Lifestyle - 5",
    image: residencesLifestyleImg5,
  },
  {
    categoryId: 7,
    name: "destination - 1",
    image: destinationLifestyleImg1,
  },
  {
    categoryId: 7,
    name: "destination - 2",
    image: destinationLifestyleImg2,
  },
  {
    categoryId: 7,
    name: "destination - 3",
    image: destinationLifestyleImg3,
  },
  {
    categoryId: 7,
    name: "destination - 4",
    image: destinationLifestyleImg4,
  },
  {
    categoryId: 7,
    name: "destination - 5",
    image: destinationLifestyleImg5,
  },
  {
    categoryId: 7,
    name: "destination - 6",
    image: destinationLifestyleImg6,
  },
  {
    categoryId: 7,
    name: "destination - 7",
    image: destinationLifestyleImg7,
  },
  {
    categoryId: 7,
    name: "destination - 8",
    image: destinationLifestyleImg8,
  },
  {
    categoryId: 7,
    name: "destination - 9",
    image: destinationLifestyleImg9,
  },
  {
    categoryId: 7,
    name: "destination - 10",
    image: destinationLifestyleImg10,
  },
];

const image360 = null;

export default {
  heroShot,
  categories,
  images: _.map(images, (image) => {
    return {
      ...image,
      category: _.find(categories, { id: image.categoryId }),
    };
  }),
  video,
  image360,
  view360: [
    // {
    //   id: "AERIAL",
    //   type: "list",
    //   src: `${baseAssetUrl}/360/aerial_perspective.jpg`,
    //   list: [],
    // },
    // {
    //   id: "INTERIOR",
    //   type: "hidden",
    //   src: `${baseAssetUrl}/360/interior/index.html`,
    //   // src: "https://forviz.com/virtual-tour/lagunapark2-interior-virtual-tour/",
    //   // src:
    //   //   "https://edm.lagunaproperty.com/2022/lagunapark2-interior-virtual-tour/index.htm",
    //   // type: "list",
    //   // src: `${assetsPath(
    //   //   "phuket-laguna-park-2"
    //   // )}/images/gallery/virtual-tour/1.jpg`,
    //   // list: [
    //   //   {
    //   //     id: "SEMI-DETACHED",
    //   //     target: "_blank",
    //   //     src: (
    //   //       <div
    //   //         style={{
    //   //           display: "flex",
    //   //           justifyContent: "center",
    //   //           alignItems: "center",
    //   //           width: "100%",
    //   //           height: "100%",
    //   //         }}
    //   //       />
    //   //     ),
    //   //   },
    //   //   {
    //   //     id: "TOWNHOME",
    //   //     target: "_blank",
    //   //     src: (
    //   //       <div
    //   //         style={{
    //   //           display: "flex",
    //   //           justifyContent: "center",
    //   //           alignItems: "center",
    //   //           width: "100%",
    //   //           height: "100%",
    //   //         }}
    //   //       />
    //   //     ),
    //   //   },
    //   // ],
    // },
    {
      id: "INTERIOR",
      type: "list",
      list: [
        {
          id: "VILLA",
          target: "_blank",
          src: (
            <iframe
              width="100%"
              height="100%"
              src="https://my.matterport.com/show/?m=RzGenJ177tk"
              frameborder="0"
              allowfullscreen
              allow="vr"
            ></iframe>
          ),
          href: "https://my.matterport.com/show/?m=RzGenJ177tk",
        },
        {
          id: "TOWNHOME",
          target: "_blank",
          src: (
            <iframe
              width="100%"
              height="100%"
              src="https://my.matterport.com/show/?m=CY6oRgpAriw"
              frameborder="0"
              allowfullscreen
              allow="vr"
            ></iframe>
          ),
          href: "https://my.matterport.com/show/?m=CY6oRgpAriw",
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/data/PhuketLagunaPark2/gallery.js